import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getProducts,
  allProducts,
  productsStatus
} from "../../features/products/productSlice";
import "./Products.css";
import Filter from "./Filter/Filter";
import Card from "./Card/Card";
import SearchBar from "../SearchBar/SearchBar";
import Footer from "../Footer/Footer";
import Banner from "../Banner/Banner";
import { initialLocation } from "../../features/locations/locationSlice";

/**
 * Component that displays the products page
 *
 * @return {JSX.Element} Products component JSX
 */
export default function Products() {
  const { id: category } = useParams();
  const productsList = useSelector(allProducts);
  const productsLoadStatus = useSelector(productsStatus);
  const selectedLocation = useSelector(initialLocation);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getProducts({
        categoryId: category == "ALL" ? "" : category,
        selectedLocation
      })
    );
  }, [dispatch, category, selectedLocation]);

  return (
    <>
      <div className="search_Container">
        <div className="search_box">
          <SearchBar />
        </div>
      </div>
      <Banner />
      {/* Always show filter (new API expects that) */}
      <Filter />

      <div className="product_container">
        {productsLoadStatus === "loading" ? (
          <div className="not_products">
            <span className="products_empty_title">Loading...</span>
          </div>
        ) : productsList.length > 0 ? (
          productsList.map((product) => <Card key={product.id} {...product} />)
        ) : (
          <div className="not_products">
            <span className="products_empty_title">
              Sorry, no products matched your search!
            </span>
            <span className="products_empty_guide">
              Enter another keyword and try
            </span>
          </div>
        )}
      </div>
      <Footer tab={"products"} />
    </>
  );
}
